module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Put-on-a-Big-Show-1280.9809c49d.jpg";